import { render, staticRenderFns } from "./RoleInfo.vue?vue&type=template&id=1f91807b&"
import script from "./RoleInfo.vue?vue&type=script&lang=ts&"
export * from "./RoleInfo.vue?vue&type=script&lang=ts&"
import style0 from "./RoleInfo.vue?vue&type=style&index=0&id=1f91807b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports